import type { SearchSort } from '@pms/shared';

interface SortControlProps {
  value: SearchSort;
  onChange: (s: SearchSort) => void;
}

const OPTIONS: { value: SearchSort; label: string }[] = [
  { value: 'recommended', label: 'Recommended' },
  { value: 'price_asc', label: 'Price: low to high' },
  { value: 'price_desc', label: 'Price: high to low' },
];

export function SortControl({ value, onChange }: SortControlProps) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="font-medium text-ink-muted">Sort</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as SearchSort)}
        aria-label="Sort results"
        className="rounded-xl border border-sand bg-white px-3 py-2 font-medium text-ink outline-none focus-visible:ring-2 focus-visible:ring-clay"
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </label>
  );
}
